<template>
  <div class="content-area">
    <div class="error-panel content-area">
      <InfoPanel v-once>
        <template slot="title"></template>
        <template slot="body">
          <div class="row">
            <div class="col-sm-12 col-xs-12 warning-text text-center">
              <h1>401 - Not Authorised</h1>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 text-center" style="margin-bottom: 10px">
              <h2>Sorry, you do not have permission to view this page.</h2>
              <p>
                This is most likely because your user session has expired and you need to log in
                again.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 text-center" style="margin-bottom: 10px">
              <h2>
                <button type="button" class="btn btn-primary btn-lg">
                  <a href="/">
                    <span
                      class="fas fa-sign-out-alt fs-2"
                      style="color: white"
                      aria-hidden="true"
                    ></span
                    ><span style="color: white">Log In</span>
                  </a>
                </button>
              </h2>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 text-center">
              <!-- <slot name="footer"></slot> -->
              <strong>Hint: </strong> If you have forgotton your password there is link on the Log
              In page that will enable you to reset your password.
            </div>
          </div>
        </template>
      </InfoPanel>
    </div>
  </div>
</template>

<script>
import InfoPanel from '@/components/InfoPanel';

export default {
  components: {
    InfoPanel,
  },
  mounted() {
    // clear down tokens
    localStorage.removeItem('access_token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token_type');
  },
};
</script>

<style></style>

<style scoped>
.error-panel {
  margin-top: 140px;
}
</style>
